(function () {
  function syncBTAToVariant() {
    // Watch for BTA dropdown changes
    const observer = new MutationObserver(() => {
      const btaValue = document.querySelector('.bta-react-select__single-value');
      if (!btaValue) return;

      // Extract guest count from BTA value e.g. "1-4 $185.00" → "1-4"
      const guestCount = btaValue.textContent.trim().split(' ')[0];

      // Find matching Shopify variant radio and click it
      const matchingRadio = document.querySelector(
        `input[type="radio"][data-option-name="Guest Count"][value="${guestCount}"]`
      );

      if (matchingRadio && !matchingRadio.checked) {
        matchingRadio.click();
      }
    });

    // Observe BTA container for changes
    const btaContainer = document.querySelector('.bta-react-select__single-value')?.closest('[class*="bta"]');
    if (btaContainer) {
      observer.observe(btaContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  // Run after DOM + BTA widget loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBTAToVariant);
  } else {
    syncBTAToVariant();
  }
})();
